import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getTestimonial } from "../Service/Api";

const DEFAULT_IMAGE =
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg";

const DUMMY_TESTIMONIALS = Array.from({ length: 6 }, (_, index) => ({
  _id: `dummy-${index + 1}`,
  name: "Name",
  designation: "parent",
  description: "description",
  attachments: "",
}));

function ParentTestimonial() {
  const [testimonialData, setTestimonialData] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const data = await getTestimonial();
        setTestimonialData(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to fetch testimonials", error);
        setTestimonialData([]);
      }
    };

    fetchTestimonials();
  }, []);

  const displayData = testimonialData.length > 0 ? testimonialData : DUMMY_TESTIMONIALS;

  const settings = {
    dots: true,
    infinite: displayData.length > 4,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: displayData.length > 1,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 786,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="parentTestimonial">
      <div className="maintitle m-auto">
        <p>what parents say</p>
        <h1>Parent Testimonials</h1>
      </div>

      <Slider {...settings}>
        {displayData.map((item, index) => {
          const image = item?.attachments
            ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com?url=${item.attachments}`
            : DEFAULT_IMAGE;

          return (
            <div className="testimonialSlide" key={item?._id || index}>
              <div className="testimonialCard">
                <div className="authorBlock">
                  <div className="authorImageWrap">
                    <img
                      src={image}
                      alt={item?.name || "Parent"}
                      className="authorImage"
                      onError={(e) => {
                        e.currentTarget.src = DEFAULT_IMAGE;
                      }}
                    />
                  </div>

                  <div className="authorMeta">
                    <h5>{item?.name || "Name"}</h5>
                    <p>{item?.designation || "parent"}</p>
                  </div>
                </div>

                <p className="testimonialDescription" dangerouslySetInnerHTML={{ __html: item?.description || "description" }} />
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default ParentTestimonial;

